module.exports = __webpack_public_path__ + "img/04.db673477.jpg";